'use strict';
require('../../../modules/es.array.map');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'map');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/map.js
// module id = 561
// module chunks = 13